import { Classes } from "@blueprintjs/core";
import { rgba } from "polished";
import React, { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

const IconWrapper = styled.span<{
  $bare?: boolean;
  $color?: string;
  $small?: boolean;
}>`
  background-color: ${({ $bare, $color, theme }) =>
    $bare ? "transparent" : rgba($color ?? theme.iconColor, 0.1)};
  width: ${({ $bare, $small }) => ($bare ? "auto" : $small ? "26px" : "32px")};
  height: ${({ $bare, $small }) => ($bare ? "auto" : $small ? "26px" : "32px")};
  padding: ${({ $bare, $small }) => ($bare ? "0" : $small ? "3px 5px" : "6px")};
  border-radius: ${({ $bare }) => ($bare ? "0" : "50%")};
  .${Classes.ICON} {
    svg {
      width: ${({ $small }) => ($small ? 16 : 20)}px;
      height: ${({ $small }) => ($small ? 16 : 20)}px;
      color: ${({ $color }) => $color};
    }
  }
`;

export interface HexTitleIconProps extends ComponentPropsWithoutRef<"span"> {
  children: React.ReactNode;
  color?: string;
  small?: boolean;
  /** Render the icon without the tinted circular background. */
  bare?: boolean;
}

export const HexTitleIcon: React.ComponentType<HexTitleIconProps> = ({
  bare = false,
  color,
  small = false,
  ...props
}) => <IconWrapper $bare={bare} $color={color} $small={small} {...props} />;
